module.exports = __webpack_public_path__ + "static/Hamid Yuksel.9dca9c5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Hamid Yuksel.jpg
// module id = 1213
// module chunks = 6166952557895